import { uniqueId } from "@tm/utils"
import { ReactNode, useCallback } from "react"
import { SnackbarType, snackbarState } from "."
import { useSetRecoilState } from "recoil"

export function useSnackbar() {
    const setMessages = useSetRecoilState(snackbarState)

    const addMessage = useCallback(
        (content: ReactNode, type: SnackbarType, icon?: ReactNode, isCloseable = true, autoClose = true) => {
            const id = uniqueId()
            setMessages((state) => [...state, { id, content, type, icon, isCloseable, autoClose }])
            return {
                changeMessage: (content: ReactNode, type: SnackbarType, icon?: ReactNode, onClose?: () => void, autoClose = true) => {
                    setMessages((state) => {
                        const index = state.findIndex((x) => x.id === id)
                        if (index !== -1) {
                            return [
                                ...state.slice(0, index),
                                { ...state[index], content, type, icon, isCloseable, autoClose },
                                ...state.slice(index + 1),
                            ]
                        }
                        return state
                    })
                },
                removeMessage: () => setMessages((status) => [...status.filter((x) => x.id !== id)]),
            }
        },
        [setMessages]
    )

    return { addMessage }
}
